module.exports = __webpack_public_path__ + "img/7.39a3b131.jpg";